import { ISideMenuCategoryLang } from '../../../types/lang'

export const sideMenuCategoryLang: ISideMenuCategoryLang = {
	side_menu_category: {
		affiliate_title: 'Affiliate',
		revenue_title: 'Revenue',
		profile_title: 'PROFILE',
	}
}